/** Topics aide admin granulaires — BT-028-R1 (FR). */

export const helpTopicsAdminFr028R1 = {
  "public-home": {
    key: "public-home",
    screenLabel: "Accueil public",
    purpose: "Découvrir le portail Phase 1 Shotokan AAMC Black Dragon et le périmètre démo.",
    actions: [
      "Parcourir dojos, instructeurs et documents publics.",
      "Repérer le bandeau [DÉMO] et les emplacements en attente client.",
      "Demander un compte ou se connecter avec les comptes démo.",
    ],
    warning: "Données [DÉMO] — 10 dojos officiels en attente du fichier client.",
    nextStep: "Explorer les dojos ou se connecter en Hanshi pour l'admin.",
  },
  login: {
    key: "login",
    screenLabel: "Connexion",
    purpose: "Accéder à un espace selon le rôle démo (admin, sensei, sempai, parent, étudiant).",
    actions: [
      "Utiliser identifiant/mot de passe démo (liste affichée).",
      "Exemple : admin/demo, sensei/demo, etudiant/demo.",
      "Changer de langue FR/EN avant connexion si besoin.",
    ],
    warning: "Comptes locaux Phase 1 uniquement — pas de production.",
    nextStep: "Après connexion, utiliser le menu ou onglets de votre rôle.",
  },
  "account-request": {
    key: "account-request",
    screenLabel: "Demande de compte",
    purpose: "Formulaire de demande — enregistrement local démo, pas d'approbation automatique.",
    actions: ["Remplir identité et rôle souhaité.", "Soumettre — stockage local Phase 1."],
    warning: "[DÉMO] — aucune création de compte réelle automatique.",
    nextStep: "Utiliser un compte démo pour tester immédiatement.",
  },
  "admin-dashboard": {
    key: "admin-dashboard",
    screenLabel: "Tableau de bord admin",
    purpose: "Vue d'ensemble Hanshi : organisation, activités, progression et Shotokan.",
    actions: [
      "Utiliser les 6 groupes repliables de la sidebar.",
      "Shotokan Black Dragon pour titres et Documents & Preuves.",
      "Import CSV ou import contrôlé documents selon besoin.",
    ],
    checklist: ["Documents & Preuves n'est pas un lien principal — uniquement dans Shotokan."],
    warning: "Phase 1 — pas de paiements ni présences opérationnelles. Données [DÉMO].",
    nextStep: "Ouvrir Gestion instructeurs ou Shotokan selon la tâche.",
  },
  "admin-instructors": {
    key: "admin-instructors",
    screenLabel: "Gestion instructeurs",
    purpose: "Gérer Sensei, Sempai et leadership — données démo ou reçues, association dojo à confirmer.",
    actions: [
      "Rechercher, trier et filtrer par statut.",
      "Ajouter ou modifier un instructeur (démo).",
      "Repérer les badges [DÉMO] et statuts « À confirmer ».",
    ],
    checklist: ["Vérifier l'association dojo avant toute présentation client."],
    warning: "Leadership reçu, à confirmer — pas de reconnaissance externe affichée comme officielle.",
    nextStep: "Associer Sensei ↔ dojo quand le fichier client revient.",
  },
  "admin-dojos": {
    key: "admin-dojos",
    screenLabel: "Gestion dojos",
    purpose: "Gérer emplacements dojo, villes et assignations Sensei.",
    actions: ["Rechercher et filtrer les dojos.", "Ajouter ou modifier un emplacement démo.", "Assigner un Sensei responsable."],
    warning: "Emplacements [DÉMO] — fichier client en attente.",
    nextStep: "Vérifier Gestion instructeurs pour les liens Sensei ↔ dojo.",
  },
  "admin-students": {
    key: "admin-students",
    screenLabel: "Gestion étudiants",
    purpose: "Listes étudiants par dojo — jeu initial minimal BT-046 (Marcel Charette, Natalie Lavigne) ; import massif ultérieur.",
    actions: ["Rechercher par nom ou groupe.", "Filtrer par statut.", "Ajouter ou modifier une fiche."],
    warning: "Grades et groupes « à confirmer » — seul l'enfant [DÉMO] sert à tester l'espace Parent.",
    nextStep: "Import CSV ou fichier client après validation Hanshi.",
  },
  "admin-assistants": {
    key: "admin-assistants",
    screenLabel: "Assistants / Sempai",
    purpose: "Gérer les assistants Sempai — rôle limité Phase 1.",
    actions: ["Consulter la liste des assistants.", "Filtrer par dojo ou statut.", "Ajouter une fiche démo si besoin."],
    warning: "[DÉMO] — le Sempai ne peut pas valider un grade ni attribuer un titre.",
    nextStep: "Vérifier les classes assistées dans l'espace Sempai.",
  },
  "admin-parents": {
    key: "admin-parents",
    screenLabel: "Gestion parents",
    purpose: "Liens parent ↔ enfant — données démo Phase 1.",
    actions: ["Rechercher un parent.", "Consulter les enfants associés.", "Filtrer par statut."],
    warning: "Paiements non gérés en Phase 1. [DÉMO].",
    nextStep: "Vérifier l'espace Parent pour la cohérence des liens.",
  },
  "admin-shotokan": {
    key: "admin-shotokan",
    screenLabel: "Shotokan Black Dragon",
    purpose: "Module titres, reconnaissances, autorité et Documents & Preuves intégrés.",
    actions: [
      "Consulter vue d'ensemble et sous-menus.",
      "Titres et demandes — référentiel interne.",
      "Documents & Preuves via sous-menu (admin).",
    ],
    warning: "Référentiel interne — à valider selon documents d'autorité fournis. [DÉMO].",
    nextStep: "Vérifier documents requis avant toute décision.",
  },
  "admin-documents-preuves": {
    key: "admin-documents-preuves",
    screenLabel: "Documents & Preuves",
    purpose: "Gérer preuves, dossiers et journal — intégré dans Shotokan (admin).",
    actions: ["Parcourir documents, dossiers, journal.", "Import contrôlé si nécessaire."],
    warning: "Aucune validation officielle automatique — statut initial reçu — validation requise.",
    nextStep: "Import contrôlé pour ajouter un fichier client.",
  },
  "admin-documents-preuves-import": {
    key: "admin-documents-preuves-import",
    screenLabel: "Import contrôlé",
    purpose: "Importer métadonnées document client sans stockage serveur Phase 1.",
    actions: ["Saisir nom fichier.", "Aperçu avant import.", "Confirmer — statut reçu — validation requise imposé."],
    warning: "Fichier non stocké officiellement — backend sécurisé Phase 2+.",
    nextStep: "Vérifier le journal après import.",
  },
  "admin-import": {
    key: "admin-import",
    screenLabel: "Import CSV",
    purpose: "Charger dojos, Sensei et étudiants depuis CSV. Le modèle officiel BT-037 est documenté en boucle démo — import Excel réel après fichier client.",
    actions: [
      "Lire le panneau modèle officiel BT-037 (sections attendues, checklist réception).",
      "Coller CSV conforme pour l'import legacy.",
      "Aperçu puis confirmer — mode recommandé : officiel + conserver [DÉMO].",
    ],
    warning: "Aucun import automatique du fichier Excel BT-037 en Phase 1 — aucune donnée réelle.",
    nextStep: "Vérifier le tableau de bord Hanshi après import CSV démo.",
  },
  "admin-presentation-interactive": {
    key: "admin-presentation-interactive",
    screenLabel: "Présentation interactive",
    purpose: "Guider une démo client, prendre des notes par étape et générer un rapport d'amélioration — distinct de Formation et de l'Aide.",
    actions: [
      "Choisir express (25 min) ou complet (50–65 min).",
      "Suivre les 7 blocs BT-033 et ouvrir les écrans réels.",
      "Ajouter notes, questions ou dictée vocale si disponible.",
      "Générer et exporter le rapport d'amélioration.",
    ],
    warning: "[DÉMO] — ne pas présenter les données démo comme réelles. Aucun stockage serveur.",
    nextStep: "Marquer les étapes complétées puis exporter le rapport après la rencontre.",
  },
  "admin-documents": {
    key: "admin-documents",
    screenLabel: "Gestion documents",
    purpose: "Classifier documents selon visibilité — validation Hanshi requise.",
    actions: ["Rechercher un document.", "Classifier visibilité et statut.", "Ne pas publier de protocole sensible sans validation."],
    warning: "Ne pas publier automatiquement les protocoles Black Dragon / rituels.",
    nextStep: "Shotokan → Documents & Preuves pour les preuves.",
  },
  "admin-organisation": {
    key: "admin-organisation",
    screenLabel: "Organisation",
    purpose: "Structure Shotokan AAMC Black Dragon — résumé dojos et effectifs.",
    actions: ["Consulter le résumé organisation.", "Vérifier les compteurs démo."],
    warning: "Données [DÉMO] — structure officielle en attente client.",
    nextStep: "Gestion dojos pour les emplacements.",
  },
  "sensei-dashboard": {
    key: "sensei-dashboard",
    screenLabel: "Espace Sensei",
    purpose: "Gérer dojo, cours, élèves, progression et Shotokan (droits limités).",
    actions: [
      "Navigation regroupée : Mon dojo, Mes cours, Mes élèves, Progression.",
      "Shotokan Black Dragon pour titres et documents requis.",
      "Documents utiles pour partages dojo.",
    ],
    warning: "[DÉMO] — pas d'attribution officielle de titre sans autorité. Pas d'admin complète.",
    nextStep: "Ouvrir Mes cours ou Mes élèves selon la tâche.",
  },
  "sempai-dashboard": {
    key: "sempai-dashboard",
    screenLabel: "Espace Sempai",
    purpose: "Assister classes et consulter élèves — consultation uniquement.",
    actions: [
      "Classes assistées, présences légères, progression consultation.",
      "Shotokan en lecture — documents requis.",
    ],
    warning: "[DÉMO] — le Sempai ne peut pas valider un grade ni attribuer un titre.",
    nextStep: "Consulter vos classes assistées.",
  },
  "student-dashboard": {
    key: "student-dashboard",
    screenLabel: "Mon espace étudiant",
    purpose: "Vue d'ensemble : dojo, Sensei, accès rapide aux onglets.",
    actions: ["Mes cours, événements, progression, titres, documents.", "7 onglets simples en haut."],
    warning: "[DÉMO] — pas de documents confidentiels ni admin.",
    nextStep: "Ouvrir Mes cours ou Ma progression.",
  },
  "parent-dashboard": {
    key: "parent-dashboard",
    screenLabel: "Espace Parent",
    purpose: "Suivre vos enfants : horaires, événements, progression, documents autorisés.",
    actions: ["7 onglets : Mes enfants, Horaires, Événements, etc.", "Consulter fiches enfants."],
    warning: "Paiements non gérés en Phase 1. [DÉMO]. Pas d'accès Shotokan complet.",
    nextStep: "Horaires ou Progression selon le besoin.",
  },
};

export const helpFallbackFr028R1 = {
  key: "__fallback__",
  screenLabel: "Page non répertoriée",
  purpose: "Aide générique — cette route n'a pas encore de topic dédié.",
  actions: ["Utiliser le menu principal.", "Contacter l'administrateur si le problème persiste."],
  warning: "[DÉMO] — fallback technique, ne doit pas apparaître sur les routes Phase 1 principales.",
  nextStep: "Retourner à l'accueil ou au tableau de bord de votre rôle.",
};
